export function buildInstructorLessonPath({
  videoId = '',
  studentId = '',
  sport = '',
  skill = '',
  lessonId = '',
} = {}) {
  const params = new URLSearchParams();

  if (videoId) {
    params.set('videoId', videoId);
  }

  if (studentId) {
    params.set('studentId', studentId);
  }

  if (sport) {
    params.set('sport', sport);
  }

  if (skill) {
    params.set('skill', skill);
  }

  if (lessonId) {
    params.set('lessonId', lessonId);
  }

  const query = params.toString();
  return query ? `/instructor/lesson-builder?${query}` : '/instructor/lesson-builder';
}
